import { useState, type FormEvent } from 'react';
import { Link } from 'react-router-dom';

export function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [sent, setSent] = useState(false);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setSubmitting(true);
    // Fire-and-forget: server always returns 204 so we don't reveal email existence.
    await fetch('/api/v1/auth/forgot-password', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email }),
    }).catch(() => undefined);
    setSent(true);
    setSubmitting(false);
  }

  return (
    <div className="login">
      <div className="login__panel">
        <div className="login__brand">
          <img src="/design-system/assets/VIN-light.svg" alt="VIN" />
          <span className="login__brand-tag">AI Software Registry</span>
        </div>
        <div className="login__hello">Forgot your password?</div>
        <h1 className="login__headline">No problem — we'll email you a reset link.</h1>
        <p className="login__lede">
          Enter the email you sign in with. If it's on file, you'll get a one-time link from
          <em> noreply@airegistry.software</em> within a minute.
        </p>
      </div>

      <div className="login__form-side">
        <div className="login__card">
          {!sent ? (
            <>
              <h2 className="login__title">Reset password</h2>
              <p className="login__sub">Enter your work email.</p>
              <form className="login__fields" onSubmit={(e) => void onSubmit(e)}>
                <div className="field">
                  <label className="field__label" htmlFor="email">Work email</label>
                  <input
                    id="email"
                    type="email"
                    value={email}
                    autoComplete="username"
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </div>
                <button
                  className="btn btn--primary btn--block btn--lg"
                  type="submit"
                  disabled={submitting}
                >
                  {submitting ? 'Sending…' : 'Send reset link'}
                </button>
              </form>
              <p
                style={{
                  fontSize: 12,
                  color: 'var(--color-steel)',
                  textAlign: 'center',
                  marginTop: 18,
                }}
              >
                <Link to="/login">← Back to sign in</Link>
              </p>
            </>
          ) : (
            <>
              <h2 className="login__title">Check your inbox</h2>
              <p className="login__sub" style={{ marginBottom: 22 }}>
                If <strong>{email}</strong> is on file, a one-time reset link is on its way. It expires
                in 1 hour. Check spam if it doesn't show up in a minute.
              </p>
              <Link to="/login" className="btn btn--secondary btn--block btn--lg">
                Back to sign in
              </Link>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
